jQuery(document).ready(function() {

	// Quick view 'Add to Registry'
	window.giftreggie_session = {};
	window.giftreggie_sessionId = '';
	if (typeof(Cookies) != 'undefined') {
		window.giftreggie_sessionId = Cookies.get("giftreggie_session_cookie");
	}
	if (typeof(GiftReggie) == 'undefined') {
		console.log('Failed to load GiftReggie');
		return;
	}

	gift_reggie_mod_pages(giftreggie_sessionId);

	// Gift reggie pages
	$('.giftreggie-front').addClass('container py-14');

	if (typeof(SHOP.customer) != 'undefined' &&
		typeof(GiftReggie) != 'undefined' &&
		!$('body').hasClass('template--product')) {
		GiftReggie
			.getSession(SHOP.customer.id, SHOP.customer.email, SHOP.customer.grss)
			.done(function(data) {
				window.giftreggie_session = data;
				if (typeof(data.sessionId) != 'undefined') {
					giftreggie_sessionId = data.sessionId;
				}
				if (typeof(window.giftreggie_init_wishlisting) != 'undefined')
					window.giftreggie_init_wishlisting();
			});
	}
	/*{
	   if(giftreggie_sessionId) {
	     giftreggie_sessionId = null;
	     $.ajax({ url: '/cart/update.js', type: "POST", data: {
	       'attributes[registry_admin]': '',
	       'attributes[registry_id]': '',
	     } }).done(function() {
	       Cookies.remove("giftreggie_session_cookie");
	     });
	   }
	 }*/
	window.giftreggie_publish_atr_button = function(div) {
		var form = $(div).parents("form");
		var currentLanguage = SHOP.curr_lang;
		var languageParam = currentLanguage != "" ? "&lang=" + encodeURIComponent(currentLanguage) : "";
		var languageInitialParam = languageParam != "" ? languageParam.replace("&", "?") : "";
		var defaultLanguage = "en";
		var buttonNames = {
			"en": "Add to Registry",
			"fr": "Ajoutez au Liste",
			"pt": "Agregar a lista"
		};
		console.log('currentLanguage', currentLanguage);
		var value = buttonNames[currentLanguage] ? buttonNames[currentLanguage] : buttonNames[defaultLanguage];
		if (form.length > 0 && /cart/.test(form.attr('action'))) {
			$("<input type='button' class='btn btn-secondary' value='" + value + "'>").appendTo(div).click(function() {
				if (typeof(SHOP.cart_atts.registry_id) != 'undefined' &&
					typeof(SHOP.cart_atts.registry_admin) != 'undefined' &&
					typeof(SHOP.customer) != 'undefined') {
					var id = form.find("input[name='id'], select[name='id']").val();
					var quantity = form.find("input[name='quantity']").val();
					var properties = {};
					form.find("input, select").each(function() {
						if (!$(this).is(':disabled')) {
							if (($(this).attr('type') == 'checkbox' || $(this).attr('type') == 'radio') && !$(this).is(':checked'))
								return;
							var groups = /properties\[([^\]]+)\]/.exec($(this).attr('name'));
							if (groups && groups.length > 1) {
								properties[groups[1]] = $(this).val();
							}
						}
					});
					if (!quantity)
						quantity = 1;
					// We add to the DOM in this manner to deal with IE issues.
					if (id) {
						var property_attributes = "";
						for (var i in properties) {
							if (properties.hasOwnProperty(i)) {
								property_attributes += '<input type="hidden" name="properties[' + i + ']" value="' + (properties[i] != null ? properties[i].replace(/"/g, "'") : "") + '"/>';
							}
						}
						var registry_id = SHOP.cart_atts.registry_id;
						$('<form style="display:none" method="post" action="/apps/giftregistry/registry/' + registry_id + '/add?sid=' + encodeURIComponent(giftreggie_sessionId) + languageParam + '">' +
							property_attributes +
							'<input type="hidden" name="id" value="' + id + '">' +
							'<input type="hidden" name="quantity" value="' + quantity + '">' +
							'</form>').appendTo("body").submit();
					} else {
						alert("Unable to integrate this snippet properly with your theme. Please remove or modify it to comply with your theme. For help modifying the snippet, please contact gift-reggie@eshopadmin.com.");
					}
				} else {
					if (typeof(SHOP.customer) != 'undefined') {
						if (giftreggie_sessionId)
							window.location = "/apps/giftregistry/create?sid=" + encodeURIComponent(giftreggie_sessionId) + languageParam;
						else
							window.location = "/apps/giftregistry/create" + languageInitialParam;
					} else {
						window.location = "/apps/giftregistry/signup" + languageInitialParam;
					}
				}
				return false;
			});
		} else {
			alert("Unable to integrate this snippet properly with your theme. Please remove or modify it to comply with your theme. For help modifying the snippet, please contact gift-reggie@eshopadmin.com.");
		}
		return false;
	};
	// END: Quick view 'Add to Registry'

	// Quick view 'Add to Wishlist'
	window.giftreggie_wishlist = null;
	window.giftreggie_wl_variant_ids = {};
	window.giftreggie_init_wishlisting = function() {
		if (typeof(SHOP.cart_atts.wishlist_variant_ids) == 'undefined') {
			if (typeof(window.giftreggie_session.getWishlist) == 'undefined') {
				$('.grid-item .btn.add-to-wishlist-button').hide();
				return;
			}
			window.giftreggie_session.getWishlist().done(function(data) {
				var variantIdList = [];
				if (data['wishlist']) {
					window.giftreggie_wishlist = data.wishlist;
					for (var i = 0; i < data.wishlist.products.length; ++i) {
						variantIdList.push(data.wishlist.products[i].variant_id);
						window.giftreggie_wl_variant_ids[data.wishlist.products[i].variant_id] = 1;
					}
					$.ajax({
						url: '/cart/update.js',
						type: "POST",
						data: {
							"attributes[wishlist_variant_ids]": "[" + variantIdList.join(", ") + "]",
							"attributes[wishlist_id]": window.giftreggie_wishlist.id
						}
					});
				}
			});
		} else {
			var variantIdList = JSON.parse(SHOP.cart_atts.wishlist_variant_ids);
			for (var i = 0; i < variantIdList.length; ++i)
				window.giftreggie_wl_variant_ids[variantIdList[i]] = 1;
			window.giftreggie_wishlist = {
				id: SHOP.cart_atts.wishlist_id
			};
		}
	};
	if (typeof(window.giftreggie_session) != 'undefined' &&
		window.giftreggie_wishlist == null) {
		window.giftreggie_init_wishlisting();
	}

	window.giftreggie_wl_button_template = $('<button type="submit" class="btn btn-grey-outline add-wishlist"><i class="icon-heart-outline s-4"></i></button>');
	window.giftreggie_find_id_form = function(form) {
		var $target = form.find("input[name='id'], select[name='id']");
		return $target.length > 0 ? $target.val() : false;
	};
	window.giftreggie_error_message = 'Unable to integrate this snippet properly with your theme. Please remove or modify it to comply with your theme. For help modifying the snippet, please contact support@eshopadmin.com.';

	window.giftreggie_check_in_wl = function(variant_id) {
		return (typeof(window.giftreggie_wl_variant_ids[variant_id]) != 'undefined');
	};

	window.giftreggie_async_add_to_wishlist = function(variant_id) {
		if (typeof(variant_id) == 'undefined' ||
			isNaN(variant_id)) return false;
		if (!window.giftreggie_session) {
			window.location = "/apps/giftregistry/wishlist?id=" + variant_id;
			return false;
		}
		if (!window.giftreggie_wishlist) {
			window.giftreggie_session.openWishlist().done(function(data) {
				window.giftreggie_wishlist = data.wishlist;
				window.giftreggie_session.addWishlist(variant_id).done(function() {
					window.giftreggie_wl_variant_ids[variant_id] = 1;
					var variantIdList = Object.keys(window.giftreggie_wl_variant_ids);
					$.ajax({
						url: '/cart/update.js',
						type: "POST",
						data: {
							"attributes[wishlist_variant_ids]": "[" + variantIdList.join(", ") + "]",
							"attributes[wishlist_id]": window.giftreggie_wishlist.id
						}
					});
				});
			});
		} else {
			if (!window.giftreggie_wl_variant_ids[variant_id]) {
				window.giftreggie_session.addWishlist(variant_id).done(function() {
					window.giftreggie_wl_variant_ids[variant_id] = 1;
					var variantIdList = Object.keys(window.giftreggie_wl_variant_ids);
					$.ajax({
						url: '/cart/update.js',
						type: "POST",
						data: {
							"attributes[wishlist_variant_ids]": "[" + variantIdList.join(", ") + "]",
							"attributes[wishlist_id]": window.giftreggie_wishlist.id
						}
					});
				});
			}
		}
	};

	window.giftreggie_async_remove_from_wishlist = function(variant_id) {
		if (typeof(variant_id) == 'undefined' ||
			isNaN(variant_id)) return false;
		if (!window.giftreggie_session) {
			window.location = "/apps/giftregistry/wishlist?id=" + variant_id;
			return false;
		}
		if (!window.giftreggie_wishlist) {} else {
			window.giftreggie_session.removeWishlist(variant_id).done(function() {
				delete window.giftreggie_wl_variant_ids[variant_id];
				var variantIdList = Object.keys(window.giftreggie_wl_variant_ids);
				$.ajax({
					url: '/cart/update.js',
					type: "POST",
					data: {
						"attributes[wishlist_variant_ids]": "[" + variantIdList.join(", ") + "]",
						"attributes[wishlist_id]": window.giftreggie_wishlist.id
					}
				});
			});
		}
	};

	// This is the function you want to call whenever your form changes.
	window.giftreggie_wl_update_button = function(div) {
		var form = div.closest('form'),
			variant_id = window.giftreggie_find_id_form(form),
			string = '<i class="icon-heart-outline s-4"></i>',
			in_wishlist = false;
		if (window.giftreggie_check_in_wl(variant_id) == true) {
			string = '<i class="icon-heart s-4"></i>';
			in_wishlist = true;
		}
		$('.grid-item[current-variant-id="12093912055916"] .add-to-wishlist-button i').removeClass(in_wishlist ? 'icon-heart-outline' : 'icon-heart').addClass(in_wishlist ? 'icon-heart' : 'icon-heart-outline');
		div.find(".add-wishlist").html(string);
	};

	window.giftreggie_publish_atw_button = function(div) {
		var form = div.parents("form");
		if (form.length > 0 && /cart/.test(form.attr('action'))) {
			var wishlistButton = window.giftreggie_wl_button_template.clone();
			wishlistButton.appendTo(div).click(function() {
				var id = window.giftreggie_find_id_form(form);
				if (id) {
					if (!window.giftreggie_session) {
						window.location = "/apps/giftregistry/wishlist?id=" + id;
						return false;
					}
					wishlistButton.val("...");
					if (!window.giftreggie_wishlist) {
						window.giftreggie_session.openWishlist().done(function(data) {
							window.giftreggie_wishlist = data.wishlist;
							window.giftreggie_session.addWishlist(id).done(function() {
								window.giftreggie_wl_variant_ids[id] = 1;
								var variantIdList = Object.keys(window.giftreggie_wl_variant_ids);
								wishlistButton.html('<i class="icon-heart s-4"></i>');
								setTimeout(function() {
									window.giftreggie_wl_update_button(div);
								}, 1000);
								$.ajax({
									url: '/cart/update.js',
									type: "POST",
									data: {
										"attributes[wishlist_variant_ids]": "[" + variantIdList.join(", ") + "]",
										"attributes[wishlist_id]": window.giftreggie_wishlist.id
									}
								});
							});
						});
					} else {
						if (!window.giftreggie_wl_variant_ids[id]) {
							window.giftreggie_session.addWishlist(id).done(function() {
								window.giftreggie_wl_variant_ids[id] = 1;
								wishlistButton.html('<i class="icon-heart s-4"></i>');
								setTimeout(function() {
									window.giftreggie_wl_update_button(div);
								}, 1000);
								var variantIdList = Object.keys(window.giftreggie_wl_variant_ids);
								$.ajax({
									url: '/cart/update.js',
									type: "POST",
									data: {
										"attributes[wishlist_variant_ids]": "[" + variantIdList.join(", ") + "]",
										"attributes[wishlist_id]": window.giftreggie_wishlist.id
									}
								});
							});
						} else {
							window.giftreggie_session.removeWishlist(id).done(function() {
								delete window.giftreggie_wl_variant_ids[id];
								wishlistButton.html('<i class="icon-heart-outline s-4"></i>');
								setTimeout(function() {
									window.giftreggie_wl_update_button(div);
								}, 1000);
								var variantIdList = Object.keys(window.giftreggie_wl_variant_ids);
								$.ajax({
									url: '/cart/update.js',
									type: "POST",
									data: {
										"attributes[wishlist_variant_ids]": "[" + variantIdList.join(", ") + "]",
										"attributes[wishlist_id]": window.giftreggie_wishlist.id
									}
								});
							});
						}
					}
				} else
					alert(window.giftreggie_error_message);
				return false;
			});
			$('body').delay(1000).promise().done(function() {
				window.giftreggie_wl_update_button(div);
			});
		} else
			alert(window.giftreggie_error_message);
		form.find("select[name='id']").change(function() {
			window.giftreggie_wl_update_button(div);
		});
		return false;
	};
	// END: Quick view 'Add to Wishlist'

	// render registry and wishlist buttons on quick view load
	window.kb_quickview_openned = function() {
		$('.ngdialog #AddToCartForm .gift-reggie-button').each(function() {
			giftreggie_publish_atr_button($(this));
		});
		$('.ngdialog #AddToCartForm .gift-reggie-wishlist-button').each(function() {
			giftreggie_publish_atw_button($(this))
		});
	};

	// Gift reggie registry page update cart button
	if ($('form.giftreggie-registry-form').length > 0) {
		var gr_update_cart_check_interval = setInterval(function() {
				gr_update_cart_check();
			}, 1000),
			gr_last_cart_fetch;

		function gr_update_cart_check() {
			if ($('#status-bar').is(':visible') &&
				$('#status-bar').html().indexOf('Successfully modified cart!') > -1) {
				console.log('cart modified');
				gr_cart_updated();
			}
		}

		function gr_cart_updated() {
			if (typeof(gr_last_cart_fetch) == 'undefined' ||
				(new Date()).getTime() - gr_last_cart_fetch > 1000 * 15) {
				gr_last_cart_fetch = (new Date()).getTime();
				window.location.reload();
			}
		}
	}

});

window.onload = function() {

	/*var $lang_switch = $('#ly-languages-switcher');
	$('a[href*="/apps/giftregistry"]').each(function(i, item) {
	  var href = $(item).attr('href'),
	      lang_code = $lang_switch.find('option:selected').text().toLowerCase() == 'french' ? 'fr' : 'en';
	  if(href.indexOf('lang=') < 0) {
	    href = href.indexOf('?') > -1 ? href.replace('?', '?lang='+lang_code+'&') : href+'?lang='+lang_code;
	    if(typeof giftreggie_sessionId != 'undefined'
	    && href.indexOf('sid=') < 0) {
	      href = href.indexOf('?') > -1 ? href+'&sid='+giftreggie_sessionId : href+'?sid='+giftreggie_sessionId;
	    }
	    $(item).attr('href', href);
	  }
	});*/

	if (SHOP.customer &&
		SHOP.customer.email) {
		$('a[href="/apps/giftregistry/signup"]').attr('href', "/apps/giftregistry/create?sid=" + encodeURIComponent(giftreggie_sessionId || Cookies.get("giftreggie_session_cookie")));
	}

	// Gift reggie registry page update cart button
	if ($('form.giftreggie-registry-form').length > 0) {
		$('#giftreggie-checkout').hide().after('<button type="button" class="mobile-checkout-btn" onclick="window.location=\'/cart\'">Checkout</button>');
	}

};

function gift_reggie_mod_pages(giftreggie_sessionId) {

	var lang = typeof($('body').attr('data-lang')) == 'undefined' ? 'en' : $('body').attr('data-lang').toLowerCase();

	// Landing page
	var $giftreggie_wrap = $('.giftreggie-front.giftreggie-landing, .giftreggie-front.giftreggie-find');
	if ($giftreggie_wrap.length > 0) {
		if ($giftreggie_wrap.hasClass('giftreggie-find'))
			$giftreggie_wrap.addClass($giftreggie_wrap.find('form.gift-reggie-search-form').length > 0 ? 'giftreggie-search-form' : 'giftreggie-search-results');
		if ($giftreggie_wrap.find('.giftreggie-mod-wrap').length == 0) {
			$giftreggie_wrap.children().wrapAll('<div class="giftreggie-mod-wrap" />');
			$giftreggie_wrap.find('.giftreggie-mod-wrap').wrap('<div class="giftreggie-mod-bg" />');
		}
		$giftreggie_wrap.find('h3').after('<h1>' + ($giftreggie_wrap.hasClass('giftreggie-find') ? $giftreggie_wrap.find('h3').html().replace(' Gift', '') : (lang == 'fr' ? 'Registre Bébé' : 'Baby Registry')) + '</h1>').empty().remove();
		$giftreggie_wrap.find('a[href*="/create"] h4, a[href*="/signup"] h4').html('Create A Registry').attr('title', lang == 'fr' ? 'Créer un registre' : 'Create A Registry');
		$giftreggie_wrap.find('a[href*="/find"] h4').html('Find A Registry').attr('title', lang == 'fr' ? 'Trouver un registre' : 'Find A Registry');
		$giftreggie_wrap.find('a[href*="/manage"] h4, a[href*="/login"] h4').html('Manage Your Registries').attr('title', lang == 'fr' ? 'Gérez vos registres' : 'Manage Your Registries');
		$giftreggie_wrap.find('a[href*="/create"], a[href*="/signup"]').prependTo($giftreggie_wrap.find('a[href*="/create"], a[href*="/signup"]').parent());
	}

	// Signup / Login, Create & Edit registry page
	var $giftreggie_wrap = $('.giftreggie-front.giftreggie-signup, .giftreggie-front.giftreggie-login, .giftreggie-front.giftreggie-create, .giftreggie-front.giftreggie-registry');
	if ($giftreggie_wrap.length > 0) {
		if ($giftreggie_wrap.find('.giftreggie-mod-wrap').length == 0) {
			$giftreggie_wrap.find('.giftreggie-body').wrapAll('<div class="giftreggie-mod-wrap" />');
			$giftreggie_wrap.find('.giftreggie-mod-wrap').wrap('<div class="giftreggie-mod-bg" />');
		}
		$giftreggie_wrap.find('[name="registrant-title"], [name="coregistrant-title"]').each(function(i, item) {
			$(item).after('<select name="' + $(item).attr('name') + '">' +
				(lang == 'fr' ?
					'<option value="None">Aucun</option><option value="Mr.">Monsieur</option><option value="Mrs.">Madame</option><option value="Miss">Mademoiselle</option><option value="Ms">Mme</option><option value="Other">Autre</option>' :
					'<option value="None">None</option><option value="Mr.">Mr.</option><option value="Mrs.">Mrs.</option><option value="Miss">Miss</option><option value="Ms">Ms</option><option value="Other">Other</option>'
				) +
				'</select>');
			$(item).empty().remove();
		});
		if ($giftreggie_wrap.find('.after-shipping').length > 0 &&
			$giftreggie_wrap.find('.after-shipping').contents()[2].tagName == 'P' &&
			$($giftreggie_wrap.find('.after-shipping').contents()[2]).contents().length == 0) {
			$($giftreggie_wrap.find('.after-shipping').contents()[0]).add($giftreggie_wrap.find('.after-shipping').contents()[1]).appendTo($($giftreggie_wrap.find('.after-shipping').contents()[2]));
		}
		$giftreggie_wrap.find('#about-type').html('<option value="" selected="">' + (lang == 'fr' ? 'Sélectionner' : 'Select') + '...</option><option value="Facebook">Facebook</option><option value="Instagram">Instagram</option><option value="Google">Google</option><option value="Friends/Family">' + (lang == 'fr' ? 'Amis ou famille' : 'Friends/Family') + '</option><option value="Other">' + (lang == 'fr' ? 'Autre' : 'Other') + '</option>');
		$giftreggie_wrap.find('#before-shipping-selector, #after-shipping-selector').find('[value="above"]').text(lang == 'fr' ? 'Identique à «Informations de contact»' : 'Same as “Contact Information”');
		$giftreggie_wrap.find('#before-shipping-selector, #after-shipping-selector').find('[value="below"]').text(lang == 'fr' ? 'Adresse différente' : 'Different Address');
		/* REMOVE ITEM BUTTON ON MOBILE NOT WORKING BECAUSE GIFTREGGIE IS NOT LOADING CORRESPONDING PRODUCTS TABLE ON MOBILE RESOLUTION
		$giftreggie_wrap.find('li.registry-variant').each(function(i, li_registry_variant) {
		  var $li_registry_variant = $(li_registry_variant);
		  $li_registry_variant.append('<p><button type="button" class="remove-product-from-registry">Remove</button></p>');
		});
		$giftreggie_wrap.find('li.registry-variant .remove-product-from-registry').click(function(e) {
		  e.preventDefault();
		  let $this = $(this),
		      $li_registry_variant = $this.closest('li.registry-variant'),
		      $tr_registry_variant; console.log('$giftreggie_wrap', $giftreggie_wrap);
		  $giftreggie_wrap.find('tr.registry-variant').each(function(i, tr_registry_variant) { console.log('Comparing', $(tr_registry_variant).find('.variant-id'), $li_registry_variant.find('.variant-id'));
		    if($(tr_registry_variant).find('.variant-id').val() == $li_registry_variant.find('.variant-id').val())
		      $tr_registry_variant = $(tr_registry_variant);
		  }); console.log('$tr_registry_variant', $tr_registry_variant);
		  if($tr_registry_variant.length > 0)
		    $tr_registry_variant.find('[value^="delete-"]').trigger('click');
		});*/
	}

	// View registry
	var $giftreggie_wrap = $('.giftreggie-front.giftreggie-registry');
	if ($giftreggie_wrap.length > 0) {
		if ($giftreggie_wrap.find('.giftreggie-mod-wrap').length == 0) {
			$giftreggie_wrap.find('.giftreggie-body').wrapAll('<div class="giftreggie-mod-wrap" />');
			$giftreggie_wrap.find('.giftreggie-mod-wrap').wrap('<div class="giftreggie-mod-bg" />');
		}
		$giftreggie_wrap.find('#discard-changes').html('Discard');
		$giftreggie_wrap.find('p.giftreggie-no-products, p.giftreggie-browse-add-products').appendTo($giftreggie_wrap.find('.giftreggie-header'));
		$giftreggie_wrap.find('p.giftreggie-no-products a, p.giftreggie-browse-add-products a').html(lang == 'fr' ? 'Ajouter des produits' : 'Add Products');
		if (!$giftreggie_wrap.hasClass('giftreggie-guest')) {
			$giftreggie_wrap.find('tr.registry-variant input.giftreggie-line-number').each(function(i, item) {
				$(item).attr('type', 'hidden').after($(item).val());
			});
			$giftreggie_wrap.find('.action-buttons').addClass('split').children().wrapAll('<div class="text-right"></div>');
			$giftreggie_wrap.find('.action-buttons').prepend('<div class="text-left"><a href="/collections/all" class="button">' + (lang == 'fr' ? 'Ajouter des produits' : 'Add Products') + '</a></div>');
		}
		$giftreggie_wrap.find('tr.registry-variant a.giftreggie-item-name').attr('target', '_blank');
		if ($giftreggie_wrap.is('.giftreggie-guest')) {
			$.ajax({
				url: '/cart.js',
				method: 'GET',
				dataType: 'json',
				context: $giftreggie_wrap
			}).done(function(cart) {
				let $giftreggie_wrap = $(this);
				$.each(cart.items, function(i, cart_item) {
					$giftreggie_wrap.find('tr.registry-variant input.variant-id[value="' + cart_item.variant_id + '"]').closest('tr').find('input.registry-variant-quantity').val(cart_item.quantity);
				});
				$giftreggie_wrap.find('.giftreggie-registry-summary .giftreggie-mobile p').each(function(i, item) {
					var item_html = $(item).html();
					if (item_html.indexOf(':') > -1) {
						item_html = '<strong>' + item_html.replace(':', ':</strong>');
					}
					$(item).html(item_html);
				});
				$giftreggie_wrap.find('tr.registry-variant td.giftreggie-needs-quantity').each(function(i, item) {
					var needs_qty = $(item).html() * 1,
						in_cart_qty = $(item).closest('tr').find('input.registry-variant-quantity').val() * 1,
						variant_id = $(item).closest('tr').find('input.variant-id').val(),
						$mobile_reg_variant = $giftreggie_wrap.find('ul.giftreggie-view-registry li.registry-variant input.variant-id[value="' + variant_id + '"]').closest('li');
					$(item).nextAll('td').eq(0).children().hide();
					$(item).nextAll('td').eq(0).append(
						needs_qty > in_cart_qty ?
						(in_cart_qty > 0 ? '<div class="items-in-cart-note">' + in_cart_qty + (lang == 'fr' ? ' articles dans le panier' : ' items in cart') + '</div>' : '') + '<button class="kb-giftreggie-add-to-cart btn">' + (lang == 'fr' ? 'Ajouter au chariot' : 'Add to Cart') + '</button>' :
						(needs_qty == 0 ? '' : 'Added. <a href="/cart" title="View cart">' + (lang == 'fr' ? 'Voir le panier' : 'View cart') + '</a>')
					);
					$mobile_reg_variant.find('.giftreggie-add-to-cart').hide();
					$mobile_reg_variant.find('table').before(
						'<div class="kb-reg-atc-mobile' + (needs_qty == in_cart_qty ? ' added-all' : '') + '">' +
						(
							needs_qty > in_cart_qty ?
							'<button class="kb-giftreggie-add-to-cart-mobile btn">' + (lang == 'fr' ? 'Ajouter au chariot' : 'Add to Cart') + '</button>' :
							(needs_qty == 0 ? '' : 'Added. <a href="/cart" title="View cart">' + (lang == 'fr' ? 'Voir le panier' : 'View cart') + '</a>')
						) +
						'</div>'
					);
					if (in_cart_qty > 0) {
						$mobile_reg_variant.find('table').addClass('items-in-cart').find('tr').append('<th>In Cart</th><td>' + in_cart_qty + '</td>');
						//$giftreggie_wrap.find('form.giftreggie-registry-form .action-buttons.giftreggie-desktop').addClass('giftreggie-mobile');
                        $giftreggie_wrap.find('form.giftreggie-registry-form .action-buttons').show();
					}
				});
				$giftreggie_wrap.find('.kb-giftreggie-add-to-cart, .kb-giftreggie-add-to-cart-mobile').click(function(e) {
					e.preventDefault();
					var $this = $(this),
						qty = $this.closest('.registry-variant').find('.registry-variant-qty-to-add').val() * 1,
						variant_id = $this.closest('.registry-variant').find('input[name="variant-id"]').length > 0 ? $this.closest('.registry-variant').find('input[name="variant-id"]').val() : '';
					if (variant_id != '' &&
						qty > 0 &&
						!$giftreggie_wrap.hasClass('adding-items')) {
						$giftreggie_wrap.addClass('adding-items');
						const registryTitle = $('.giftreggie-registry-title');
						const registryEventDate = $('.giftreggie-desktop tr:nth-child(2) td:nth-child(4)');
						$.ajax({
							url: '/cart/add.js',
							method: 'POST',
							dataType: 'json',
							data: {
								attributes: {
									_gr_registry_address: Cookies.get('giftreggie-address'),
									_gr_registry_name: registryTitle.length > 0 ? registryTitle.html().trim() : '',
									_gr_registry_event_date: registryEventDate.length > 0 ? registryEventDate.html().trim() : ''
								},
								items: [{
									id: variant_id,
									quantity: qty,
									properties: {
										_registry_id: SHOP.cart_atts.registry_id
									}
								}]
							}
						}).done(function(response) {
							window.location = window.location.href; //$this.hide().after('Added. <a href="/cart" title="View cart">View cart</a>');
						}).always(function(response) {
							$giftreggie_wrap.removeClass('adding-items');
						});
					}
				});
				gift_reggie_mod_pages_on_cart_fetch();
			});
		}
	}

	// Manage page
	var $giftreggie_wrap_manage_page = $('.giftreggie-front.giftreggie-manage');
	if ($giftreggie_wrap_manage_page.length > 0 &&
		$giftreggie_wrap_manage_page.find('.giftreggie-body table a[href*="/apps/giftregistry/registry/"]').length > 0) {
		$giftreggie_wrap_manage_page.addClass('giftreggie-registries-listing');
		if ($giftreggie_wrap_manage_page.find('.giftreggie-mod-wrap').length == 0) {
			$giftreggie_wrap_manage_page.find('.giftreggie-body').wrapAll('<div class="giftreggie-mod-wrap" />');
			$giftreggie_wrap_manage_page.find('.giftreggie-mod-wrap').wrap('<div class="giftreggie-mod-bg" />');
		}
	}

	// Utilities
	var $giftreggie_main_wrap = $('.giftreggie-front');
	if ($giftreggie_main_wrap.find('.datepicker').length > 0) {
		var head = document.getElementsByTagName('head')[0];
		var link = document.createElement('link');
		link.rel = 'stylesheet';
		link.type = 'text/css';
		link.href = 'https://cdn.jsdelivr.net/npm/flatpickr/dist/flatpickr.min.css';
		link.media = 'all';
		head.appendChild(link);
		var script = document.createElement('script');
		script.src = 'https://cdn.jsdelivr.net/npm/flatpickr';
		script.onload = function() {
			$('.datepicker').flatpickr({
				dateFormat: 'm/d/Y',
				minDate: (new Date()).getTime()
			});
		};
		head.appendChild(script);
	}
	$giftreggie_main_wrap.find('.giftreggie-no-products a, .giftreggie-browse-add-products a').addClass('button');

}

function gift_reggie_mod_pages_on_cart_fetch() {
	console.log('[gift_reggie_mod_pages_on_cart_fetch]');

	var $giftreggie_wrap = $('.giftreggie-front.giftreggie-registry');
	if ($giftreggie_wrap.length > 0) {
		if ($giftreggie_wrap.is('.giftreggie-guest')) {
			$giftreggie_wrap.find('#view-registry tr').eq(0).find('th').last().before('<th>Qty</th>');
			$giftreggie_wrap.find('tr.registry-variant').each(function(i, item) {
				var needs = $(item).find('.giftreggie-needs-quantity').html() * 1,
					in_cart_qty = $(item).find('input.registry-variant-quantity').val() * 1,
					qty_to_add = qty_to_add = needs - in_cart_qty,
					variant_id = $(item).find('input.variant-id').val(),
					$mobile_reg_variant = $giftreggie_wrap.find('ul.giftreggie-view-registry li.registry-variant input.variant-id[value="' + variant_id + '"]').closest('li');
				$(item).find('td').last().before(qty_to_add > 0 ? '<td><input type="text" class="registry-variant-qty-to-add" value="' + qty_to_add + '" /></td>' : '<td>&nbsp;</td>');
				if (qty_to_add > 0) {
					var mobile_select_options = '';
					for (var x = 1; x <= qty_to_add; x++) {
						mobile_select_options += '<option value="' + x + '"' + (x == qty_to_add ? ' selected=""' : '') + '>' + x + '</option>';
					}
					//$mobile_reg_variant.find('.kb-reg-atc-mobile').addClass('has-qty').append('<span class="qty"><select class="registry-variant-qty-to-add">'+mobile_select_options+'</select></span>');
					$mobile_reg_variant.find('table').addClass('has-qty').find('tr').append('<th class="qty-label">Qty</th><td class="qty-select"><select class="registry-variant-qty-to-add">' + mobile_select_options + '</select></td>');
				}
			});
			$giftreggie_wrap.find('span button#registry-update-cart').closest('span').empty().remove();
		}
	}

}